<template>
  <div>
    <text-field
      multiline
      :rows="20"
      id="expression"
      label="Expression"
      :modelValue="v$.expression.$model"
      @update:modelValue="expressionChanged"
    >
      <template v-slot:validation v-if="v$.expression.$error">
        <validation-error v-if="!v$.expression.required"
          >You must supply an expression.</validation-error
        >
        <validation-error v-if="!v$.expression.validExpression">{{
          validationError
        }}</validation-error>
      </template>
    </text-field>
    <div v-if="helpAvailable" class="help">
      <a :href="helpUrl" target="_blank">
        <icon name="fa-question-circle" class="help-icon" />
        Get help with expressions.
      </a>
    </div>
  </div>
</template>
<script>
import { required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import ValidationError from "@/components/common/forms/ValidationError.vue";
import debounce from "@/util/debounce";
import expressionValidation from "@/services/sharedo/expressionValidationService";
import { openExpressionHelp } from "@/util/urlBuilder";

const created = function () {
  const vm = this;
  this.expressionChanged = debounce(function (value) {
    vm.v$.expression.$model = value;
  }, 750);
};

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  components: { ValidationError },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      validationError: "",
    };
  },
  computed: {
    expression: {
      get: function () {
        return this.modelValue;
      },
      set: function (value) {
        this.$emit("update:modelValue", value);
      },
    },
    isValid: function () {
      return !this.v$.$invalid;
    },
    helpAvailable: function () {
      return !!this.capabilities.openExpressionHelp;
    },
    helpUrl: function () {
      return openExpressionHelp();
    },
  },
  watch: {
    isValid: function (newValue) {
      this.$emit("validate", newValue);
    },
  },
  validations() {
    return {
      expression: {
        required,
        validExpression: async function (value, vm) {
        this.logDebug("Validating expression.", { expression: value });

        if (!helpers.req(value)) {
          return true;
        }

        try {
          const response = await expressionValidation.validate(value);
          vm.validationError = response.error || "";

          if (!response.error) {
            this.logInfo("Expression is valid.", { expression: value });
          } else {
            this.logWarning("Expression is invalid.", {
              expression: value,
              error: response.error,
            });
          }

          return !response.error;
        } catch (error) {
          this.logError("Unable to validate expression.", {
            expression: value,
            error,
          });
          return false;
        }
        },
      },
    };
  },
  emits: ["update:modelValue", "validate"],
  created,
};
</script>
<style lang="scss" scoped>
.help {
  margin-top: 5px;

  & > a:hover {
    text-decoration: none;
  }
}
</style>